import { Bell, CheckSquare, FileText, Search } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const Card = ({ icon: Icon, title, text, className = "", accent = "text-cyan", children, testid }) => (
  <div data-testid={testid} className={`flex h-full flex-col rounded-2xl border border-white/10 bg-card p-8 transition-transform duration-300 hover:scale-[1.02] lg:p-10 ${className}`}>
    <Icon className={`h-6 w-6 ${accent}`} />
    <h3 className="mt-6 font-display text-xl font-semibold">{title}</h3>
    <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{text}</p>
    {children}
  </div>
);

const TaskList = () => (
  <ul className="mt-8 grid gap-2 font-mono text-xs">
    {["Email Prof. about the essay topic", "Revise slides 12–20 for the quiz", "Book a room for Thursday's group"].map((t) => (
      <li key={t} className="flex items-center gap-3 rounded-xl border border-white/10 bg-background/60 px-4 py-3">
        <span className="h-3 w-3 rounded-sm border border-pink" />{t}
      </li>
    ))}
  </ul>
);

export const Features = () => (
  <section data-testid="features-section" className="border-t border-white/5 py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHead eyebrow="What you get" title="Not just a transcript. A secretary." sub="Other apps give you a wall of text. Tilla' tells you what to do next." />
      <div className="grid gap-6 lg:grid-cols-3 lg:grid-rows-2">
        <Reveal className="lg:col-span-2 lg:row-span-2">
          <Card testid="feature-tasks" icon={CheckSquare} accent="text-pink" className="beam border-transparent" title="Creates tasks and reminders on its own"
            text={`Say "the assignment is due Monday" and Tilla' adds the task and sets the reminder. You never have to scroll back through a recording to find what you promised.`}>
            <TaskList />
            <div className="mt-4 flex items-center gap-3 font-mono text-xs text-pink"><Bell className="h-4 w-4" /> Reminder set · Monday 08:00</div>
          </Card>
        </Reveal>
        <Reveal delay={0.1}>
          <Card testid="feature-summaries" icon={FileText} title="Smart summaries" text="A 2-hour lecture becomes the five points that actually matter." />
        </Reveal>
        <Reveal delay={0.2}>
          <Card testid="feature-search" icon={Search} title="Searchable notes" text={`Type "mitochondria" and find the exact moment it was mentioned — across every recording.`} />
        </Reveal>
      </div>
    </div>
  </section>
);
